import { RETRY_DELAY_MS } from './constants.js';
export function withRetry(retryLimit, callback) {
    return withRetryImpl(retryLimit, 0, callback);
}
async function withRetryImpl(retryLimit, currentRetry, callback) {
    try {
        const remainingRetries = retryLimit - currentRetry;
        return await callback(remainingRetries);
    }
    catch (err) {
        if (currentRetry < retryLimit) {
            await delay(RETRY_DELAY_MS);
            return withRetryImpl(retryLimit, currentRetry + 1, callback);
        }
        throw err;
    }
}
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
